import { InlineEditableField } from 'app/components/Common/EditPage/InlineEditableField';
import { CustomTextField } from 'app/components/Placement/PlacementDetails/Edit/CustomComponents/CustomTextField';
import { selectPlacementStatus } from 'store/redux-store/placement-status/selectors';
import React, { useContext } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { CreatePlacementContext } from '../../CreatePlacementWrapper';
import { createPlacementTabIDs } from '../../helper';
import { isInitialStatus, isWFC } from '../../../NextPlacementStatus/StatusDefaults';
import { selectNewPlacementChoice } from '../../../../../../store/redux-store/new-placement/selectors';

export const RequestedShifts = ({ ...props }) => {
  const { control } = useFormContext();
  const { setCurrentFocusId } = useContext(CreatePlacementContext);
  const { candidate } = useSelector(selectNewPlacementChoice);
  const { currentPlacementStatus } = useSelector(selectPlacementStatus);

  return (
    <Controller
      name="requestedShift"
      control={control}
      render={({ field: { value, ...rest } }) => (
        <InlineEditableField
          id={createPlacementTabIDs.createPlacementRequestedShifts}
          {...rest}
          label={value}
          inputProps={{ value, minWidth: 80, renderedFromInlineEditor: true }}
          Control={CustomTextField}
          setCurrentFocus={() => setCurrentFocusId(createPlacementTabIDs.createPlacementRequestedShifts)}
          disabled={!candidate || !(isWFC(currentPlacementStatus) || isInitialStatus(currentPlacementStatus))}
        />
      )}
    />
  );
};
